import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InformationItemComponent } from "./information-item.component";

@NgModule({
  declarations: [
    InformationItemComponent
  ],
  imports: [CommonModule],
  exports: [
    InformationItemComponent
  ],
})
export class InformationItemModule { }
